import React from 'react';
import logo from '../../../../../assets/images/logoNutri.jpg';
import moment from 'moment';

export const TemplatePresupuestoIOMA = ({ presupuesto = {}, isIOMA, isConFecha }) => {
    return (
        <div id='presupuesto-content'
            style={{
                fontFamily: 'Arial, sans-serif',
                border: '1px solid',
                padding: 10,
                background: 'white',
                width: '150mm',
                boxSizing: 'border-box',
                fontSize: 10,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div style={{ flex: 10 }}
                >
                    <img
                        src={logo}
                        alt='Logo Nutrihome'
                        style={{ width: 190, height: 45, }}
                    />
                </div>
                <div style={{ display: 'flex', flex: 15 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h3 style={{ margin: '5px 0' }}>X</h3>
                        <h4 style={{ marginTop: 5, marginBottom: 0 }}>DOCUMENTO NO VALIDO</h4>
                        <h4 style={{ marginTop: 5 }}>COMO FACTURA</h4>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ fontSize: 8 }}>
                    <p style={{ fontSize: 10, margin: 0 }}>Delegación: <strong>{presupuesto.delegacion}</strong></p>
                    <p style={{ fontSize: 10, margin: 0 }}>{presupuesto.direccionDelegacion}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>Casa Central - Av. Cabildo 2677 Piso10 (C1428AUU) Buenos Aires</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>Tel: 0810-555-6887</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>IVA: RESPONSABLE INSCRIPTO</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', fontSize: 8 }}>
                    <p style={{ margin: '4px 0' }}>CUIT: 30-69118223-8</p>
                    <p style={{ margin: '4px 0' }}>Ing. Brutos C.M.: 901-042808-1</p>
                    <p style={{ margin: '4px 0' }}>Fecha Inicio Actividades: 20/04/1997</p>
                </div>
            </div>
            <div style={{ width: '100%', border: '1px solid', textAlign: 'center', marginTop: 5 }}>
                <h3 style={{ margin: 0, lineHeight: '13px' }}>PRESUPUESTO</h3>
            </div>
            <div style={{ width: '100%', display: 'flex', gap: 5 }}>
                <div style={{ flex: 1, fontSize: 8 }}>
                    <p style={{ margin: '4px 0' }}>
                        {isIOMA ? 'Anexo 1 de iNH-OP-005' : `NH-PON-AC-001 ${isConFecha ? 'A' : 'B'}/00`}
                    </p>
                </div>
                <div style={{ flex: 1 }}>
                    <p style={{ margin: '4px 0' }}>Nro. Presupuesto: <strong>{presupuesto.idEvaluacion}</strong></p>
                </div>
                <div style={{ flex: 1, fontSize: 10 }}>
                    <p style={{ margin: '4px 0' }}>{presupuesto.dia ? `${presupuesto.dia} de ${presupuesto.mes} del ${presupuesto.anio}` : ''}</p>
                </div>
            </div>
            <div style={{ padding: 10, paddingRight: 50, fontSize: 9 }}>
                <p>Sres.: <strong style={{ marginLeft: 15 }}>{presupuesto.razonSocial} / Área de Soporte</strong></p>
                <p>Atención: <strong style={{ marginLeft: 15 }}>{presupuesto.atencion}</strong></p>
                <p>
                    Por medio de la presente hago llegar a Ud. el presupuesto por el módulo
                    <strong> {presupuesto.modulo}</strong> del paciente:
                </p>

                <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                    <p style={{ flex: 1, margin: '5px 0' }}>Paciente: </p>
                    <strong style={{ flex: 6 }}>{presupuesto.paciente}</strong>
                </div>

                <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                    <p style={{ flex: 1, margin: '5px 0' }}>Obra social: </p>
                    <strong style={{ flex: 6 }}> {presupuesto.razonSocial}</strong>
                </div>

                <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                    <p style={{ flex: 1, margin: '5px 0' }}>Nro. Afiliado: </p>
                    <strong style={{ flex: 6 }}>{presupuesto.numeroAfiliado}</strong>
                </div>

                {isIOMA && <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                    <p style={{ flex: 1, margin: '5px 0' }}>Se solicitan:  </p>
                    <p style={{ flex: 6, margin: '5px 0' }}> <strong>{presupuesto.dias}</strong> DIAS DESDE LA FECHA DE INICIO, ENTRE  {moment(presupuesto.fechaDesde).format('DD/MM/YYYY')} y {moment(presupuesto.fechaHasta).format('DD/MM/YYYY')}.</p>
                </div>}

                {/* {!isIOMA && <div>
                    <p>
                        Condición del paciente ante el IVA: <strong>{presupuesto.ivaPaciente}</strong> (declaro que esta es la condición ante el IVA del paciente de referencia) <strong>SI - NO</strong>
                    </p>
                </div>} */}

                <p style={{ fontSize: 9, lineHeight: '12px', paddingRight: 30 }}>
                    El servicio se brindará en {presupuesto.direccionPaciente} domicilio dispuesto por la
                    familia del mencionado paciente. Si el paciente se muda del domicilio, el servicio queda suspendido desde el momento
                    en que abandona dicho domicilio, debiendo en su caso y con antelación solicitar evaluación y presupuesto para el futuro
                    domicilio.
                </p>

                {isConFecha && <p style={{ fontSize: 10, lineHeight: '18px', paddingRight: 30 }}>
                    Se envía presupuesto por {presupuesto.dias} días a partir del <strong>{moment(presupuesto.fechaDesde).format('DD/MM/YYYY')}</strong>  hasta el <strong>{moment(presupuesto.fechaHasta).format('DD/MM/YYYY')}</strong>.
                </p>}

                <p style={{ marginBottom: 0 }}>
                    <strong>${presupuesto.precioDiario} ({presupuesto.descripcionPrecioDiario})</strong> Por día del programa de
                    asistencia.
                </p>
                {isIOMA && <strong>
                    TOTAL DEL PRESUPUESTO: ${presupuesto.total} ({presupuesto.descripcionTotal})
                </strong>}
                {!isIOMA && <div>
                    <p style={{ margin: 0 }}>-El precio del módulo <strong><u>NO</u></strong> incluye <strong>IVA</strong> . </p>
                    <p style={{ margin: 0 }}>-Condición de pago: 30 días de la fecha de la factura. </p>
                    <div style={{ marginTop: 20 }}>
                        <strong><u>Se adjunta composición del Módulo</u></strong>
                    </div>
                </div>}

                <div style={{ marginTop: 17 }}>
                    <p style={{ marginBottom: 0 }}>EN CASO DE REQUERIR EL MENCIONADO SERVICIO, SOLICITAMOS:</p>
                    <p style={{ marginTop: 0 }}> - Nos envíen el presupuesto firmado aclarando la condición de IVA del paciente.</p>
                </div>

                {!isIOMA && <div>
                    <p style={{ margin: 0 }}> <strong>ESTE PRESUPUESTO TENDRÁ VIGENCIA DESDE EL DÍA EN QUE SE EMITA LA AUTORIZACIÓN DEL MISMO Y
                        QUEDARA VIGENTE HASTA LA NOTIFICACIÓN FEHACIENTE POR PARTE DEL CLIENTE DE LA SUSPENSIÓN
                        DEL SERVICIO.</strong></p>
                    <p style={{ margin: 0, opacity: isConFecha ? 1 : 0 }}><strong>LA FECHA DE FINALIZACIÓN ANTES MENCIONADA ES SOLO A TITULO DE REQUISITOS PARA FACTURACIÓN.</strong></p>
                    <p style={{ margin: 0 }}> <strong> NUTRIHOME PODRÁ SUSPENDER LA PRESTACIÓN DE SUS SERVICIOS POR FALTA DE PAGO Y/O FALTA DE
                        AUTORIZACIÓN DE LAS PRESTACIONES EN TIEMPO Y FORMA.</strong></p>
                    <p style={{ margin: 0, marginTop: 20 }}><strong>EL INICIO DEL SERVICIO QUEDARA SUJETO A LA EVALUACION CREDITICIA FINAL QUE REALICE NUTRIHOME.</strong></p>
                </div>}

                <p style={{ marginTop: isIOMA ? 40 : 15 }} >Sin otro particular saluda atentamente.</p>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: isIOMA ? 80 : 50 }}>
                    <p style={{ fontStyle: 'italic' }}>Responsable del Área Comercial</p>
                </div>

                {isIOMA && <div>
                    <p style={{ lineHeight: '12px', fontSize: 8.5, marginBottom: 0 }}>El presente presupuesto fue realizado en base a la evaluación médica preliminar del paciente y puede sufrir posteriores
                        modificaciones si por indicación médica se modificara la dieta y/o el número de visitas de enfermería. En este último caso
                        NutriHome S.A. notificará pidiendo autorización para el nuevo presupuesto actualizado en base a la nueva indicación médica. SI
                        LA O.S. NO RESPONDIERA AUTORIZANDO O RECHAZANDO EL NUEVO PRESUPUESTO, SE ENTENDERÁ QUE EL
                        PRESUPUESTO HA SIDO AUTORIZADO. NutriHome S.A. suspenderá la prestación de sus servicios por falta de pago y/o falta de
                        autorización de las prestaciones en tiempo y forma.
                    </p>
                    <p style={{ lineHeight: '12px', fontSize: 8.5, marginTop: 0 }}>
                        El modulo nutricional domiciliario es un servicio programado y como tal requiere del tiempo necesario para la evaluación
                        médico asistencial del ingreso del paciente al sistema que permite garantizar la calidad del servicio.
                    </p>
                </div>}
                {!isIOMA && <div>
                    <p style={{ fontSize: 8.5, marginBottom: 0, whiteSpace: 'break-spaces' }}>
                        {'NOTA: \nEl modulo nutricional domiciliario es un servicio programado y como tal requiere del tiempo necesario para la evaluación médico asistencial del ingreso del paciente al sistema que permite garantizar la calidad del servicio.\nEl presente presupuesto fue realizado en base a la evaluación médica preliminar del paciente y puede sufrir modificaciones si por indicación médica se modificara la dieta y/o el número de visitas de enfermería, notificándose al financiador.\nQueda sujeto a decisión de la empresa la aceptación de brindar el servicio en caso de que alguna condición se modifique.'}
                    </p>
                </div>
                }
            </div>
        </div >

    )
}
